/**
 * Runtime marker prefix for window dimension values
 * Used to mark style values that need runtime evaluation via useWindowDimensions()
 */
export const RUNTIME_DIMENSIONS_MARKER = "{{RUNTIME:dimensions.";
